var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile() && _vm.navContainer)?_c('div',{key:_vm.key,staticClass:"nav-container scrollable"},[_vm._t("sidebar-body")],2):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c61cdcb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/responsive-sidebar.vue
// module id = /FTQ
// module chunks = 0